<template>
    <div id="main-wrapper">
        <NavbarDark/>
        <section class="bg-primary position-relative">
            <div class="position-absolute start-0 top-0 w-25 h-15 bg-light rounded-end-pill opacity-25 mt-4"></div>
            <div class="position-absolute start-0 bottom-0 w-15 h-20 bg-light rounded-top-pill opacity-25 ms-4"></div>
            <div class="position-absolute end-0 top-0 w-15 h-25 bg-light rounded-bottom-pill opacity-25 me-4"></div>
            <div class="position-absolute end-0 bottom-0 w-25 h-15 bg-light rounded-start-pill opacity-25 mb-4"></div>
            <div class="ht-30"></div>
            <div class="ht-30"></div>
        </section>

        <section class="gray-simple">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="item-shorting-box">
                            <div class="item-shorting clearfix">
                                <div class="left-column pull-left">
                                    <h4 class="m-0 fs-6">
                                        {{ $t('Found Result') }} {{ totalResults }} 
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center g-4">
                    <div v-if="cities.length === 0">
                        <p>{{ $t('There is no city until now!') }}</p>
                    </div>
                        <Gridcityall :item="cities"/>
                </div>
                <div id="scroll-sentinel" class="text-center my-4">
                    <span v-if="loading">{{ $t('Downloading..') }}</span>
                </div>
            </div>		
        </section>

        <FooterTop :bg="'theme-bg'"/>
        <FooterDark/>
        <ScrollToTop/>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import axios from 'axios';
import Gridcityall from '@/components/property/gridcity-all.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import { useI18n } from "vue-i18n"; 
const cities = ref([]);
const currentPage = ref(1);
const totalPages = ref(1);
const totalResults = ref(0);
const perPage = ref(0);
const from = ref(0);
const to = ref(0);
const loading = ref(false);
const observer = ref(null);
const { locale } = useI18n();

const fetchcities = async () => {
    if (loading.value || currentPage.value > totalPages.value) return;

    loading.value = true;
    try {
        const response = await axios.get(`/cities?page=${currentPage.value}&lang=${locale.value}`);
        
        if (currentPage.value === 1) {
            cities.value = response.data.data;
        } else {
            cities.value.push(...response.data.data);
        }

        totalResults.value = response.data.total;
        perPage.value = response.data.per_page;
        from.value = (currentPage.value - 1) * perPage.value + 1;
        to.value = Math.min(from.value + cities.value.length - 1, totalResults.value);
        totalPages.value = response.data.last_page;
        currentPage.value++;

    } catch (error) {
        console.error("Error fetching cities:", error);
    } finally {
        loading.value = false;
    }
};

const setupObserver = () => {
    observer.value = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !loading.value) {
            fetchcities();
        }
    });

    const sentinel = document.getElementById('scroll-sentinel');
    if (sentinel) observer.value.observe(sentinel);
};

onMounted(() => {
    fetchcities();
    setupObserver();
});

onUnmounted(() => {
    if (observer.value) observer.value.disconnect();
});
</script>

